import { getTranslation } from "@/data/translations";

export const extractDurationPricePairs = (pricing: string): Array<{ duration: string; price: string }> => {
    const pairs: Array<{ duration: string; price: string }> = [];
    const regex = /(\d+)\s*Min:\s*(\d+)\s*CHF/g;
    let match;
    while ((match = regex.exec(pricing)) !== null) {
        pairs.push({ duration: match[1], price: match[2] });
    }
    return pairs;
};

export const extractDurations = (duration: string): string[] => {
    const durationRegex = /(\d+)/g;
    const matches = duration.match(durationRegex);
    return matches || [];
};

export const getSingleLanguageTitle = (title: string, translationKey: string, language: string): string => {
    if (title === translationKey || (title.includes(".") && !title.includes(" / ") && !title.includes(" "))) {
        const englishTitle = getTranslation("en", translationKey);
        if (englishTitle && englishTitle !== translationKey) {
            title = englishTitle;
        } else {
            return translationKey.split(".").pop() || title;
        }
    }

    const parts = title.split(" / ");
    if (parts.length > 1) {
        const selected = language === "de" ? parts[0] : (parts[1] || parts[0]);
        return selected.trim();
    }
    return title;
};
